import store from 'store2'

import post from './post'

export default function(event,value,data,done){

  if(!done){var done = function(){}}

  if(!event){
    done({error: 'event, value required'})

  } else {

    var s = store.namespace('omb')

    var uid = s('userId')
    var role = s('role')
    var email = s('email')
    var lang = s('lang')

    post(
      'data',
      {
        type: 'log',
        uid: uid,
        event: event,
        value: value,
        email: email,
        role: role,
        lang: lang,
        data: data,
      },
      function(error, result){
        if(error){
          done(error,result)
        } else {
          done(null,result)
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/client/lib/log.js